import { DatePipe, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractItemComponent } from '@df/catalog-ui/abstract-item.component';
import { IPageDataV2, IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { ImageModule } from '@df/module-image/image.module';
import { ICmsPage } from '@icms/core/resource/page/icms-page';
import { ActionComponent } from 'projects/app-default/src/app/ui/api/action.component';
import { ShellComponent } from '@df/ui/common/shell/shell.component';
import { LocalPage } from '../../../page.decorator';
import { NBlogCategoryPageType } from '../../page/category-view/cms-blog-page-category-view.component';
import { NBlogPostPageType } from '../../page/post-view/cms-blog-post.namespace';

@Component({
    selector: 'cms-blog-content-blog-card',
    templateUrl: './cms-blog-content-blog-card.html',
    styleUrls: ['./cms-blog-content-blog-card.scss'],
    standalone: true,
    imports: [ActionComponent, RouterLink, ShellComponent, ImageModule, UpperCasePipe, DatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsBlogContentBlogCardComponent extends AbstractItemComponent<LocalPage<IPageDataV2<NBlogPostPageType.ITypeData>>> {
    type = ICmsPage.type;
    protected tagCategories: LocalPage<IPageDataV2<NBlogCategoryPageType.ITypeData>>[] = [];

    get typeData() {
        return this?.model?.data?.typeData;
    }

    protected override onModelChange(): void {
        this.tagCategories = this.model?.getBlogPostCategories()?.slice(0, 3) || [];
        return super.onModelChange();
    }
}
